<!--
  Date + time + "sem horário" (E4 RF-04). Hyper form markup; mat-datepicker is one of the five
  allowed Material components. Remix icons only.
-->
<div class="row g-2">
  <div class="col-sm-6">
    <label class="form-label" [attr.for]="idPrefix + 'Date'">{{ 'task.moment.date' | translate }}</label>
    <div class="input-group">
      <input
        [id]="idPrefix + 'Date'"
        class="form-control"
        [matDatepicker]="picker"
        [value]="date"
        [max]="maxDate"
        [min]="minDate"
        [disabled]="disabled"
        (dateChange)="onDateChange($event.value)"
        (blur)="markTouched()"
      />
      <button
        class="btn btn-light"
        type="button"
        [disabled]="disabled"
        (click)="picker.open()"
        [attr.aria-label]="'task.moment.openCalendar' | translate"
      >
        <i class="ri-calendar-line"></i>
      </button>
    </div>
    <mat-datepicker #picker></mat-datepicker>
    @if (showDateError) {
      <span class="help-block text-danger"><small>{{ 'task.moment.dateRequired' | translate }}</small></span>
    }
  </div>

  <div class="col-sm-6">
    <label class="form-label" [attr.for]="idPrefix + 'Time'">{{ 'task.moment.time' | translate }}</label>
    <input
      [id]="idPrefix + 'Time'"
      type="time"
      class="form-control"
      [value]="time"
      [disabled]="disabled || untimed"
      (input)="onTimeChange($any($event.target).value)"
      (blur)="markTouched()"
    />
    @if (allowUntimed) {
      <div class="form-check mt-1">
        <input
          class="form-check-input"
          type="checkbox"
          [id]="idPrefix + 'Untimed'"
          [checked]="untimed"
          [disabled]="disabled"
          (change)="onUntimedChange($any($event.target).checked)"
        />
        <label class="form-check-label" [attr.for]="idPrefix + 'Untimed'">
          <i class="ri-time-line me-1 text-muted"></i>{{ 'task.moment.untimed' | translate }}
        </label>
      </div>
    }
    @if (showTimeError) {
      <span class="help-block text-danger"><small>{{ 'task.moment.timeRequired' | translate }}</small></span>
    }
  </div>
</div>
